// Blog content loader — backed by the admin-editable `blog_posts` collection.
// Posts are fetched from `${REACT_APP_BACKEND_URL}/api/blog/posts` and returned
// in the same shape the previous static module exposed (slug, title, excerpt,
// category, body[], hero_image, date, read_time), so the rest of the frontend
// only needs to switch from sync to async.
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function fetchPosts(lang) {
  const { data } = await axios.get(`${API}/blog/posts`, { params: { lang } });
  return Array.isArray(data) ? data : [];
}

export async function fetchPostBySlug(lang, slug) {
  try {
    const { data } = await axios.get(`${API}/blog/posts/${encodeURIComponent(slug)}`, {
      params: { lang },
    });
    return data || null;
  } catch {
    return null;
  }
}
